export default function createRequestActionTypes(
  prefix: string,
  postfix: string,
) {
  const TYPE = `${prefix}/${postfix}`;
  const SUCCESS = `${TYPE}_SUCCESS`;
  const FAILURE = `${TYPE}_FAILURE`;
  return [TYPE, SUCCESS, FAILURE];
}
